import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "pl-6"
}
const _hoisted_3 = {
  key: 1,
  class: "pl-6"
}
const _hoisted_4 = {
  key: 2,
  class: "pl-6"
}
const _hoisted_5 = { class: "pl-3 text-center" }
const _hoisted_6 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "audit-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "11",
            class: "ma-auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("h5", { class: "pl-4" }, "Documents liés", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "1",
            class: "d-flex align-center px-0 justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "align-center pa-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_icon, {
                        icon: _ctx.documentsExpand ? '$fa-chevron-up' : '$fa-chevron-down',
                        "data-cy": "AuditConnectedAcrDocuments-documents",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.documentsExpand = !_ctx.documentsExpand)),
                        style: {"width":"40px"},
                        class: "d-inline px-2"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.documentsExpand)
        ? (_openBlock(), _createBlock(_component_v_card_text, {
            key: 0,
            transition: "expand"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "py-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_data_table, {
                        headers: _ctx.documentsHeaders,
                        items: _ctx.localConnectedDocuments,
                        class: "table mt-3",
                        "fixed-header": "",
                        "items-per-page": -1
                      }, {
                        item: _withCtx((props) => [
                          _createElementVNode("tr", {
                            onClick: _withModifiers(($event: any) => (_ctx.openDocument(props.item.id)), ["stop"]),
                            style: {"cursor":"pointer"}
                          }, [
                            _createElementVNode("td", null, [
                              (props.item.name)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(props.item.name), 1))
                                : (
                                            props.item.accountingLines &&
                                            props.item.accountingLines[0] &&
                                            props.item.accountingLines[0].wording
                                        )
                                  ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(props.item.accountingLines[0].wording), 1))
                                  : (props.item.thirdPartyCompany)
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(props.item.thirdPartyCompany), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t("document.shortType." + props.item.type || "UNKNOWN")), 1),
                            _createElementVNode("td", _hoisted_6, [
                              (props.item.type === 'MISCELLANEOUS')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                      _createTextVNode("$dot")
                                    ])),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 1,
                                    class: "ma-2",
                                    label: "",
                                    color: _ctx.statusColor(props.item),
                                    size: "small",
                                    variant: "outlined"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.statusTooltip(props.item)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                            ])
                          ], 8, _hoisted_1)
                        ]),
                        _: 1
                      }, 8, ["headers", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}